<div class="modal-header">
    <h4 class="modal-title">Standort {{ title }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="newForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label class="control-label" for="inputIdentnummer">Identnummer<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="inputIdentnummer" name="identnummer" placeholder="Identnummer" formControlName="identnummer">
        </div>
        <div class="form-group">
            <label class="control-label" for="inputArt">Art<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="inputArt" name="Art" placeholder="Objekt Art" formControlName="objektart">
        </div>
        <div class="form-group">
            <label class="control-label" for="inputLeitstelle">Leitstelle<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="inputLeitstelle" name="leitstelle" placeholder="Leitstelle" formControlName="leitstelle">
        </div>
        <div class="form-group" *blockUI="'singleSelect'; message: 'Loading'">
            <ng-container mCardBody>
            <label class="control-label" for="inputstdo">Standort<span class="text-danger">*</span></label>
            <select class="form-control" id="inputstdo" name="stdo" formControlName="adressenid">
                <option>Bitte Auswählen</option>
                <option *ngFor="let element of adressen" [value]="element.id">{{ element.strasse }}</option>
              </select>
        </ng-container>
        </div>
      </form>
  </div>
  <div class="modal-footer">
  <button type="submit" class="btn btn-success round" (click)="onSubmit()">Hinzufügen</button>
  <button type="reset" class="btn round bg-red" style="color: white;" (click)="activeModal.close('Schließen')">Schließen</button>
  </div>
